import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import type { SupportedTranslations } from '@recruitee/i18n';
import { I18nService, phraseAppTranslationsLoader, TranslationsProvider } from '@recruitee/i18n';

import { appTranslations, rtiTranslations, uiTranslations, wysiwygTranslations } from '../locales';

@Injectable({ providedIn: 'root' })
export class AccountSetupI18nResolver {
  constructor(
    private i18n: I18nService,
    private i18nProvider: TranslationsProvider,
    private titleService: Title,
  ) {}
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.loadTranslation(<SupportedTranslations>route.params.lang);
  }

  public loadTranslation(lang: SupportedTranslations): Promise<boolean> {
    return phraseAppTranslationsLoader(lang, this.i18nProvider.defaultLocale, [
      appTranslations,
      uiTranslations,
      wysiwygTranslations,
      rtiTranslations,
    ]).then(translations => {
      this.i18nProvider.setTranslations(translations);
      this.i18n.locale = lang;
      this.titleService.setTitle(this.i18n.translate('rto.common.page_title'));
      return true;
    });
  }
}
